import { useQuery } from '@tanstack/react-query';

import { api } from '../../lib/api.js';
import { Plan } from '@raven/shared-types';
import { z } from 'zod';

export function AdminPlans() {
  const { data, isPending } = useQuery({
    queryKey: ['admin', 'plans'],
    queryFn: () => api.get('/api/admin/plans', z.object({ plans: z.array(Plan) })),
  });
  if (isPending) return <div className="card text-sm text-slate-500">Loading…</div>;
  return (
    <div className="card">
      <h3 className="text-base font-semibold">Plans</h3>
      <table className="mt-3 min-w-full text-sm">
        <thead>
          <tr className="border-b">
            <th className="text-left py-2">Name</th>
            <th className="text-left py-2">Module</th>
            <th className="text-right py-2">Renders</th>
            <th className="text-right py-2">Hits</th>
            <th className="text-right py-2">Cost</th>
            <th className="text-left py-2">Active</th>
          </tr>
        </thead>
        <tbody>
          {(data?.plans ?? []).map((p) => (
            <tr key={p.id} className="border-b last:border-b-0">
              <td className="py-2">{p.name}</td>
              <td className="py-2">{p.module}</td>
              <td className="py-2 text-right">{p.renders.toLocaleString()}</td>
              <td className="py-2 text-right">{p.hits.toLocaleString()}</td>
              <td className="py-2 text-right">{p.cost}</td>
              <td className="py-2">
                {p.is_active ? (
                  <span className="badge-success">yes</span>
                ) : (
                  <span className="badge-warning">no</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
